"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseYear = exports.parseNumber = exports.parseMonthWord = exports.parseMonth = exports.parseDayWithOrdinal = undefined;

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _uiwidgetsCommon = require("uiwidgets-common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var regxDayWithOrdinal = /(\d*)(?:st|nd|rd|th)/i;

/**
 * Parse a day with an ordinal postfix (e.g. "1st", "2nd", "3rd", "4th")
 *
 * @param s {String} the string to parse.
 * @return {Number} the day number.
 */
var parseDayWithOrdinal = exports.parseDayWithOrdinal = function parseDayWithOrdinal(s) {
    var match = regxDayWithOrdinal.exec(s);
    if (!match) {
        return undefined;
    }

    return +match[1];
};

/**
 * Parse a month from the given string. First it will try to parse it as a number, if it is a number, and it's a valid
 * number (1 to 12), then it will be used. If not, to will try to match the string to a wordy month.
 *
 * @param s {String} the string to parse.
 * @return {Number} the month number (0-11) or undefined.
 */
var parseMonth = exports.parseMonth = function parseMonth(s) {
    var result = parseNumber(s);

    // first try parsing a number...
    if (!(0, _uiwidgetsCommon.isUndefined)(result)) {
        // we have a number, but is it valid?
        if (result >= 1 && result <= 12) {
            // it is valid, substract 1 to shift to the 0-11 range.
            return result - 1;
        }

        // it is a number, but not a valid one, so we don't understand it.
        return undefined;
    }

    // fallback to a wordy month, extract an array of short months from the `moment` locale.
    result = parseMonthWord(s);

    return result;
};

/**
 * Parse a wordy month from the given string.
 *
 * @param s {String} the string to parse.
 * @return {Number} the month number (0-11) or undefined.
 */
var parseMonthWord = exports.parseMonthWord = function parseMonthWord(s) {
    var shortMonths = _moment2.default.localeData().monthsShort().map(function (mon) {
        return mon.toLowerCase();
    });

    // attempt to locate a month matching what was typed.
    var result = shortMonths.indexOf(s.substring(0, 3));
    if (result === -1) {
        return undefined;
    }

    return result;
};

/**
 * Parse a number from the given string.
 *
 * @param s {String} the string to parse.
 * @return {Number} the parsed number or undefined.
 */
var parseNumber = exports.parseNumber = function parseNumber(s) {
    var result = parseInt(s, 10);
    if (isNaN(result)) {
        return undefined;
    }

    return result;
};

/**
 * Parse a year from the given string.
 *
 * @param s {String} the string to parse.
 * @return {Number} the full year.
 */
var parseYear = exports.parseYear = function parseYear(s) {
    var value = parseNumber(s);
    if (value < 30) {
        value += 2000;
    } else if (value >= 30 && value <= 99) {
        value += 1900;
    }

    return value;
};
//# sourceMappingURL=ParseUtils.js.map